"use strict";

class DefaultGeneratorController {
    /*@ngInject*/
    constructor($state, $stateParams, inventory, iconCache, $mdDialog, orderStore, utils, $q) {
        "ngInject";
        _.extend(this, {
            name: 'home',
            $state: $state,
            $stateParams: $stateParams,
            $mdDialog: $mdDialog,
            inventory: inventory,
            getIconFor: iconCache,
            orderStore: orderStore,
            utils: utils,
            $q: $q
        });

        this.itemColumns = this.getItemColumnsFromInventory();
    }

    getItemColumnsFromInventory() {
        let primaryRootItems = this.inventory.getPrimaryRootItems(),
            miscRootItems = (this.inventory.getMiscellaneousRootItems());

        let primaryColumns = _(primaryRootItems)
            .map(rootCategory => this.utils.getItemColumn(rootCategory.qualifiedName, []))
            .map(rootCategory => this.utils.withCountsOf(rootCategory.children, rootCategory, 2))
            .map(rootCategory => this.utils.withAllUniqueItemsFromRootOf(rootCategory, 2))
            .value();

        let miscColumns =_(miscRootItems)
            .map(rootCategory => this.utils.getItemColumn(rootCategory.qualifiedName, [], 2))
            .map(rootCategory => this.utils.withCountsOf(rootCategory.children, rootCategory, 3))
            .map(rootCategory => this.utils.withAllUniqueItemsFromRootOf(rootCategory, 6))
            .value();

        return primaryColumns.concat(miscColumns);
    }

    onItemClick(evt) {
        let action = evt.action,
            selectedItem = evt.item,
            selectedItemColumn = evt.column;

        let selectedItemQualifiedName = selectedItem.qualifiedName;
        switch (action) {
            case 'add':
                selectedItemColumn.children.push(this.inventory.getItemWithQualifiedName(selectedItemQualifiedName));
                this.utils.updateCountsOf(selectedItemColumn, this.itemColumns, 2);
                break;
            case 'subtract':
                let indexOfSimilarItemInColumn = _.findLastIndex(selectedItemColumn.children, (item) =>
                    this.utils.compareQualifiedNameOf(item, selectedItemQualifiedName, 2)
                );
                if (indexOfSimilarItemInColumn !== -1) {
                    selectedItemColumn.children.splice(indexOfSimilarItemInColumn, 1);
                }
                this.utils.updateCountsOf(selectedItemColumn, this.itemColumns, 2);
                break;
        }
    }

    logItems() {
        const items = _(this.itemColumns).pluck('children').flatten().value();
        const structuredItems = this.utils.mergeOrderItems(items);
        const itemsJSON = JSON.stringify(structuredItems);
        console.log(itemsJSON);
    }
}

export default DefaultGeneratorController;



// WEBPACK FOOTER //
// ./client/app/components/default.generator/default.generator.controller.js